import { Component, OnInit, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "ke-ui-skip-to-main",
  imports: [MatButtonModule],
  templateUrl: "./skip-to-main.component.html",
  styleUrls: ["./skip-to-main.component.scss"],
})
export class SkipToMainComponent implements OnInit {
  btnText = $localize`Skip to main content`;
  elmFound = signal<HTMLElement | null>(null);

  public skipToMain(): void {
    const main = document.querySelector(".mat-drawer-content") as HTMLElement;
    if (main) {
      main.setAttribute("tabindex", "-1");
      main.focus();
    }
  }

  ngOnInit() {
    this.waitForElm(".mat-drawer-content").then((elm: any) => {
      this.elmFound.set(elm);
    });
  }

  private waitForElm(selector: string) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}
